import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import type { Patient } from "../../app-patient/_objects-patient";
import { RequestContext } from "../../request-context";
import { requestGet, requestPost, requireResult } from "../../utils/network";
import ActionButton from "../../widget/action-button";
import FormValidating from "../../widget/form-validating";
import { Modes } from "../../widget/io-abstract";
import IONumber from "../../widget/io-number";
import { MenuItem } from "./menu-item";

export function MenuPatientSearchByReference() {
  const requestCtx = useContext(RequestContext)!;
  const currentYear = new Date().getFullYear();
  const [data, updateData] = useState<Record<string, number>>({
    entry_year: currentYear,
    entry_order: 0
  });
  const [state, updateState] = useState<"" | "create" | "error">("");
  const navigate = useNavigate();
  const formMode = state == "" ? Modes.input : Modes.output;

  return (
    <FormValidating
      action={(formData: FormData) =>
        // We use the search endpoint
        requestCtx
          .fetchJSONAndMessage<Patient[]>(
            `Searching for reference ${formData.get("entry_year")}-${formData.get("entry_order")}`,
            requestGet("/api/patient/reference", formData)
          )
          .then((listing) => listing || [])
          .then((patients) => {
            if (patients.length == 1) {
              const patient = patients[0];
              navigate(`/patient/${patient.id}`);
            }
            if (patients.length == 0) {
              updateState("create");
            } else {
              updateState("error");
            }
          })
      }
      className="menu-item"
    >
      <MenuItem
        title="Search a reference"
        requires="write"
        // versalIcon={icons.models.patient}
        buttons={[
          ...(state == ""
            ? [
                <ActionButton
                  action="Search"
                  key="search"
                  style="View"
                  type="submit"
                />
              ]
            : []),
          ...(state != ""
            ? [
                <ActionButton
                  key="reset"
                  style="Reset"
                  discrete
                  type="submit"
                  onOk={() => updateState("")}
                />
              ]
            : []),
          ...(state == "create"
            ? [
                <ActionButton
                  key="create"
                  style="Add"
                  action="Create"
                  onOk={() => {
                    const fd = new FormData();
                    fd.append("entry_year", "" + data["entry_year"]);
                    fd.append("entry_order", "" + data["entry_order"]);
                    requestCtx
                      .fetchJSONAndMessage<Patient>(
                        `Creating reference ${data["entry_year"]}-${data["entry_order"]}`,
                        requestPost("/api/patient", fd)
                      )
                      .then(requireResult)
                      .then((patient: Patient) =>
                        navigate(
                          `/patient/${patient.id}/patient/${patient.id}/edit`
                        )
                      );
                  }}
                />
              ]
            : [])
        ]}
      >
        <IONumber
          mode={formMode}
          name="entry_year"
          value={data["entry_year"]}
          htmlProps={{ min: 2000, max: currentYear }}
          onChange={(val) => updateData({ ...data, entry_year: val })}
        />
        <IONumber
          mode={formMode}
          name="entry_order"
          value={data["entry_order"]}
          htmlProps={{ min: 1 }}
          onChange={(val) => updateData({ ...data, entry_order: val })}
        />
        {state == "error" && <div>Server error: multiple results received</div>}
        {state == "create" && <div>Create the selected reference?</div>}
      </MenuItem>
    </FormValidating>
  );
}
